// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

// Import Recoil
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {activeAutom, changedFields, initialActions, saveAvailable} from "../../../../recoil-store/recoil-state";
import {CheckIfFlowUpdated} from "../../../../helpers/helper";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

function Get({ action, variables, setOpenVariable, automId, setAlert, automVersionId }) {
    const [getType, setGetType] = useState("key");
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.MATE-DB.GET.';

    useEffect(() => {
        if (!action.fields.getType) {
            action.fields.getType = { value: 'key' }
        }

        setGetType(action.fields.getType.value);
    }, [action.id])

    const handleClick = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["getType"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("getType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
        if (value === 'key') {
            // delete action.fields.key;
        } else if (value === "value") {
            delete action.fields.key;
        }
        action.fields.getType = {value};
        setGetType(value);
    };


    return (
        <div>
            <div className="form-element">
                <div className="conf-field-container condition-tabs">
                    <button className={getType === 'key' ? 'condition-active' : ''}
                            value="key" onClick={handleClick}>
                        {t(label + 'BY-KEY')}
                    </button>
                    {/*<button disabled className={getType === 'value' ? 'condition-active' : ''}*/}
                    {/*        value="value" onClick={handleClick}>*/}
                    {/*    {t(label + 'BY-VALUE')}*/}
                    {/*</button>*/}
                </div>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'KEY')} is_required/>
                <TextInput action={action} inputName="key" variables={variables}
                           setOpenVariable={setOpenVariable}
                           isRequired={true} fieldType="string" displayName={t(label + 'KEY')} hideRequired/>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-DATA')}/>
                <VariablePicker action={action} inputName="set" variables={variables}
                                setOpenVariable={setOpenVariable}/>
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.FIELD-MUST-BE-STRING-TYPE')}</em></small>
            </div>
        </div>
    );
}

export default Get;